import { render, staticRenderFns } from "./dbBookingAppointment.vue?vue&type=template&id=d183d9a2&scoped=true"
import script from "./dbBookingAppointment.vue?vue&type=script&lang=js"
export * from "./dbBookingAppointment.vue?vue&type=script&lang=js"
import style0 from "./dbBookingAppointment.vue?vue&type=style&index=0&id=d183d9a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d183d9a2",
  null
  
)

export default component.exports